module.exports = __webpack_public_path__ + "img/clipboard-x.08e9c036.svg";